query AnalyticsSalesMetrics($filter: AnalyticsSalesFilterInput!) {
  analyticsSales(filter: $filter) {
    sales
    purchasers
    revenue
    currency
  }
}
